export const LABELS_INFORMATION_NAMESPACE = 'labelsInformation';

// mutations
export const SET_LABELS_INFORMATION = 'setLabelsInformation';

// actions
export const GET_LABELS_INFORMATION = 'getLabelsInformation';

export default {};
